module.exports = __webpack_public_path__ + "tree-open.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/tree-open.svg?color1=%23333333&color2=
// module id = 918
// module chunks = 67